import ReservationDeepLinkController from './ReservationDeepLinkController';

export default ReservationDeepLinkController;
